<template lang="pug">
    main
      NavBar
      Loader(v-show="isLoading")
      section.section(v-show="!isLoading")
        .container
          .columns
            .column.is-half.is-offset-one-quarter.has-text-centered
                h3.title(style='margin-bottom: 8px') Editor de {{ this.nombreSG }}
            br
          .columns
            .column.is-3
              b.has-text-black(@click="backPage")
                a.button.is-light.is-rounded
                  span.icon
                    i.fas.fa-angle-left
                  | &nbspRegresar
          .columns
            .column.is-8
              .columns
                .column.is-10.is-half.is-offset-one-quarter
                  .column.is-5
                    span Color: 
                      input(type='color' v-model="colorSG" style='width:190px;')
                  .column.is-5
                    span Botón:  
                      input(type='color' v-model='botonSG' style='width:190px;')
                  .column.is-5
                    span Texto: 
                      input#isS.is-checkradio.is-primary(type='radio', value='white' v-model='textoSG')
                      label.is-size-6(for='isS') Blanco
                      input#isF.is-checkradio.is-primary(type='radio', value='black' v-model='textoSG')
                      label.is-size-6(for='isF') Negro
                  .column.is-5
                    span Etiqueta:  
                      input#isT.is-checkradio.is-primary(type='radio', value='white' v-model='etiqSG')
                      label.is-size-6(for='isT') Blanco
                      input#isO.is-checkradio.is-primary(type='radio', value='black' v-model='etiqSG')
                      label.is-size-6(for='isO') Negro
                  .column.is-half.is-offset-one-quarter.has-text-centered
                    b.has-text-black
                      a.button.is-light.is-rounded(
                        style="margin-top:10px" @click="guardarCambios"
                        )
                          | Guardar
            .column.is-4
              .columns.is-multiline.has-text-centered
                CardEjemploSubgrupo(:nombreSG="nombreSG" :colorSG="colorSG" :textoSG="textoSG" :etiqSG="etiqSG" :botonSG="botonSG")
  </template>
  
  <script>
    import Loader from '@/components/shared/Loader.vue'
    import NavBar from './layout/NavBar.vue'
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'
    import CardEjemploSubgrupo from './componentes/CardEjemploSubgrupo.vue'
    import grupos_tpaServices from '@/services/sca/grupos/gruposTPA.js'
  
    export default {
      name: 'editarSubgrupos',
      components: { Loader, NavBar, flatPickr, CardEjemploSubgrupo, grupos_tpaServices },
      data() {
        return {
          isLoading: true,
          showFormGrupos: false,
          showFormSubgrupos: false,
          propiedadesTarj:[],
          idSub: null,
          subgrupoSelect:{}, 
          nombreSG:null,
          colorSG:null,
          textoSG:null,
          etiqSG:null,
          botonSG:null,
        }
      },
      watch: {  },
      methods: {

        iniciarComponente () {
          this.isLoading = false
        },
  
        eventLoading (val) {
          this.isLoading = val
        }, 
  
        backPage() {
          this.$store.commit('idEditarSubgrupo', null)
          this.$router.back()
        },

        obtenerSubgrupos () {
          grupos_tpaServices.obtenerSubgrupos()
            .then( data => {
              
              this.idSub = this.$store.state.idEditarSubgrupo
              this.subgrupoSelect = data.filter(subgrupo => subgrupo.id == this.idSub)

              this.nombreSG = this.subgrupoSelect[0].nombre
              this.colorSG = this.subgrupoSelect[0].config.color
              this.etiqSG = this.subgrupoSelect[0].config.etiqueta
              this.textoSG = this.subgrupoSelect[0].config.texto
              this.botonSG = this.subgrupoSelect[0].config.boton
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
            })
        },

        guardarCambios(){
          grupos_tpaServices.updateConfiguracionSubgrupo(this.idSub, this.colorSG, this.textoSG, this.etiqSG, this.botonSG )
            .then( resp => {
              if (resp.success) {
                this.$store.commit('idEditarSubgrupo', null)
                this.$router.back()
                
                let toast = this.$toasted.show(`La modificación se ha realizado correctamente.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'ban',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
              } else {
                let toast = this.$toasted.show(`Error: ${resp.respuesta}`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'ban',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
              }
            })
            .catch(e => console.log(e))
        },
      },
      created () {
        this.iniciarComponente()
        this.obtenerSubgrupos()
      },
    }
  </script>
  
  <style lang="scss" scoped>
    .column-blanco {
      padding-bottom: 100px;
    }
    .label-radio {
      margin-right: 10px;
    }
    .is-radio-input {
      padding-right: 5px;
    }
  </style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/cuartocontrol/EditarSubgrupo.vue